module.exports = __webpack_public_path__ + "static/media/icon_file_apk.6b7ae68a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_apk.svg
// module id = 145
// module chunks = 0